import {useTranslation} from "react-i18next";
import React from "react";
import illustration from "../../assets/illustrations/moin-app-illus-no-chat-messages.png";
import {makeStyles} from "@material-ui/core/styles";
import {Typography} from "@material-ui/core";
import MoinButton from "../../components/base/MoinButton";
import {Link} from "react-router-dom";
import * as ROUTES from "../../Routes";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: '64px',
        marginBottom: '64px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '768px',
        flex: '100',
    },
    illustration: {
        maxWidth: '45%',
        height: 'auto'
    },
    title: {
        marginBottom: '12px'
    },
    text: {
        textAlign: 'center'
    },
    showAllButton: {
        marginTop: '24px'
    },
}));

const ChatSearchEmptyState = () => {
    const [t, i18n] = useTranslation();

    const classes = useStyles();

    return (
        <div className={classes.paper}>
            <img src={illustration} alt={t('common.illustration')} className={classes.illustration}/>
            <Typography variant="h3" className={classes.title}>{t('chat.noChatsFound')}</Typography>
            <Typography variant="body2" className={classes.text}>{t('chat.noChatsFoundBody')}</Typography>
            <Link to={ROUTES.messagesSingleCreate}><MoinButton className={classes.showAllButton}>{t('chat.createChat')}</MoinButton></Link>
        </div>
    );
};
export default ChatSearchEmptyState;
